<template>
    <footer class="footer has-cards">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-12">
                    <div class="row row-grid">
                        <div class="col-lg-4">
                            <card class="border-0" hover shadow body-classes="py-5">
                                <icon name="ni ni-app" type="primary" rounded class="mb-4">
                                </icon>
                                <h6 class="text-primary text-uppercase">My Software projects</h6>
                                <p class="description mt-3">Most all of my public coding projects are linked to my github. A select few are production ready (like starboard), due to me jumping around a lot.</p>
                                <div>
                                    <badge type="primary" rounded>design</badge>
                                    <badge type="primary" rounded>system</badge>
                                    <badge type="primary" rounded>creative</badge>
                                </div>
                                <base-button tag="a" @click="goTo('software')" target="_blank" type="primary" class="mt-4 text-white">
                                    Learn more
                                </base-button>
                            </card>
                        </div>
                        <div class="col-lg-4">
                            <card class="border-0" hover shadow body-classes="py-5">
                                <icon name="ni ni-palette" type="success" rounded class="mb-4">
                                </icon>
                                <h6 class="text-success text-uppercase">My art</h6>
                                <p class="description mt-3">I like to draw in my free time some. I am in no way distinguished, but a few of my creations have been uploaded on here and Twitter.</p>
                                <div>
                                    <badge type="success" rounded>art</badge>
                                    <badge type="success" rounded>creative</badge>
                                </div>
                                <base-button tag="a" @click="goTo('art')" type="success" class="mt-4 text-white">
                                    Learn more
                                </base-button>
                            </card>
                        </div>
                        <div class="col-lg-4">
                            <card class="border-0" hover shadow body-classes="py-5">
                                <icon name="ni ni-circle-08" type="warning" rounded class="mb-4">
                                </icon>
                                <h6 class="text-warning text-uppercase">My socials</h6>
                                <p class="description mt-3">I barely ever use any of my socials, but if you want to follow one, I may use Twitter from time to time to send out updates or reply to messages.</p>
                                <div>
                                    <badge type="warning" rounded>socials</badge>
                                    <badge type="warning" rounded>updates</badge>
                                </div>
                                <base-button tag="a" href="https://twitter.com/rushnett" target="_blank" type="warning" class="mt-4 text-white">
                                    Learn more
                                </base-button>
                            </card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--<div class="container container-lg">
            <div class="row">
                <div class="col-md-6 mb-5 mb-md-0">
                    <div class="card card-lift--hover shadow border-0">
                        <router-link to="/landing" title="Landing Page">
                            <img v-lazy="'img/theme/landing.jpg'" class="card-img">
                        </router-link>
                    </div>
                </div>
                <div class="col-md-6 mb-5 mb-lg-0">
                    <div class="card card-lift--hover shadow border-0">
                        <router-link to="/profile" title="Profile Page">
                            <img v-lazy="'img/theme/profile.jpg'" class="card-img">
                        </router-link>
                    </div>
                </div>
            </div>
        </div>-->
        <div class="container">
            <div class="row row-grid align-items-center my-md">
                <div class="col-lg-6">
                    <h3 class="text-primary font-weight-light mb-2">Stay in touch with . . .</h3>
                    <h4 class="mb-0 font-weight-light"></h4>
                </div>
                <div class="col-lg-6 text-lg-center btn-wrapper">
                    <a target="_blank" rel="noopener" href="https://twitter.com/rushnett"
                       class="btn btn-neutral btn-icon-only btn-twitter btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Follow me pls">
                        <font-awesome-icon :icon="['fab', 'twitter']" size="lg"></font-awesome-icon>
                    </a>
                    <a target="_blank" rel="noopener" href="https://twitch.tv/rushnett"
                       class="btn btn-neutral btn-icon-only btn-purple btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Follow me">
                        <font-awesome-icon :icon="['fab', 'twitch']" size="lg"></font-awesome-icon>
                    </a>
                    <a target="_blank" rel="noopener" href="https://www.youtube.com/user/rushnettt"
                       class="btn btn-neutral btn-icon-only btn-dribbble btn-lg btn-round" data-toggle="tooltip"
                       data-original-title="Follow me">
                        <font-awesome-icon :icon="['fab', 'youtube']" size="lg"></font-awesome-icon>
                    </a>
                    <a target="_blank" rel="noopener" href="https://github.com/rushnett"
                       class="btn btn-neutral btn-icon-only btn-github btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Check out my Github">
                        <font-awesome-icon :icon="['fab', 'github']" size="lg"></font-awesome-icon>
                    </a>
                </div>
            </div>
            <hr>
            <div class="row align-items-center justify-content-md-between">
                <div class="col-md-6">
                    <div class="copyright">
                        &copy; {{year}}
                        <a target="_blank" rel="noopener"><router-link to="/profile">Rushnett</router-link></a>.
                    </div>
                </div>
                <div class="col-md-6">
                    <ul class="nav nav-footer justify-content-end">
                        <!--<li class="nav-item">
                            <a href="https://www.creative-tim.com/presentation" class="nav-link" target="_blank" rel="noopener">About</a>
                        </li>-->
                        <!--<li class="nav-item">
                            <a href="http://blog.creative-tim.com" class="nav-link" target="_blank" rel="noopener">Blog</a>
                        </li>-->
                        <!--<li class="nav-item">
                            <a href="https://github.com/creativetimofficial/argon-design-system/blob/master/LICENSE.md"
                               class="nav-link" target="_blank" rel="noopener">MIT License</a>
                        </li>-->
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
  name: 'app-footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
};
</script>
<style>
</style>
